

import React from 'react';

interface LegalModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
}

const LegalModal: React.FC<LegalModalProps> = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="legal-modal-title"
        >
            <div
                className="bg-light-surface dark:bg-surface rounded-lg shadow-xl w-full max-w-3xl border border-light-border dark:border-border flex flex-col max-h-[90vh]"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center p-6 border-b border-light-border dark:border-border flex-shrink-0">
                    <h2 id="legal-modal-title" className="text-2xl font-bold text-light-text-primary dark:text-text-primary">
                        {title}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-light-text-secondary dark:text-text-secondary hover:text-light-text-primary dark:hover:text-text-primary transition-colors"
                        aria-label="Cerrar modal"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>
                <div className="p-6 sm:p-8 overflow-y-auto prose dark:prose-invert max-w-none prose-p:text-light-text-secondary prose-p:dark:text-text-secondary prose-strong:text-light-text-primary prose-strong:dark:text-text-primary prose-a:text-blue-600 prose-a:dark:text-blue-400 prose-ul:list-disc prose-ul:ml-6">
                    {children}
                </div>
                 <div className="p-4 bg-gray-100 dark:bg-gray-800 border-t border-light-border dark:border-border flex-shrink-0 text-right rounded-b-lg">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-md bg-primary hover:bg-blue-600 text-white font-semibold transition-colors"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LegalModal;
